export default {
	RegisterdeclarationNetwork: 'Đăng ký nộp tờ khai qua mạng',
	UnRegisterdeclarationNetwork: 'Đăng ký ngừng nộp tờ khai qua mạng',
	RegisterdeclarationNetworkHaunt: 'Đăng ký địa bàn vãng lai',
	UnRegisterdeclarationNetworkHaunt: 'Đăng ký ngừng địa bàn vãng lai',
	DvcDeclarationNotNeedRegis: 'Tờ khai bạn chọn đã được chuyển sang Cổng Dịch vụ công, vì vậy không cần đăng ký.',
	ReRegister: 'Đăng ký lại',
	RegisterHistory: 'Lịch sử đăng ký',
	Declaration: 'Tờ khai',
	TypeDeclarationPeriod: 'Loại kỳ kê khai',
	StartedPeriod: 'Kỳ bắt đầu',
	EndedPeriod: 'Kỳ kết thúc',
	AddRow: 'Thêm dòng',
	DeleteAll: 'Xóa hết dòng',
	Cancel: 'Hủy bỏ',
	SignAndSubmit: 'Ký và gửi',
	SelectedFromRegisterHistory: 'Chọn tờ khai từ lịch sử đăng ký',
	SelectDeclaration: 'Nhập mã hoặc tên tờ khai',
	InputDeclarationFilter: 'Nhập tên tờ khai để tìm kiếm',
	InputDeclarationFilterHaunt:
		'Nhập tên cơ quan thuế, tên tờ khai để tìm kiếm',
	ErrorSelectedHistory: 'Bạn chưa chọn tờ khai nào',
	TaxPeriod: 'Kỳ khai thuế',
	Selected: 'Chọn',
	RegisterSuccess: 'Đăng ký nộp tờ khai thành công',
	UnRegisterSuccess: 'Đăng ký ngừng nộp tờ khai thành công',
	WarningStopUnReguster: 'Bạn phải chọn ít nhất 1 tờ khai để ngừng',
	TaxAgentCode: 'Mã cơ quan thuế',
	TaxAgentName: 'Tên cơ quan thuế',
	TaxAgent: 'Cơ quan thuế',
	SelectTaxAgent: 'Nhập mã hoặc tên cơ quan thuế',
	GdtServiceCode: 'Mã tờ khai'
};
